import modalTaskInstanceDeleteConfirm from '../components/taskTemplates/modalTaskInstanceDeleteConfirm.html';

export default async function maybeWarnAboutDeleting(Authentication, $uibModal) {
  if (!Authentication.user.settings.clientFlags.doNotWarnAgainAboutDeletingTaskTemplates) {
    const doNotWarnAgain = await $uibModal.open({
      templateUrl: modalTaskInstanceDeleteConfirm,
      size: '580',
      controllerAs: 'ctrl',
      controller: function ctrl() {
        this.text =
          'Deleting a template will not affect tasks which were already assigned. Existing tasks attached to shifts will have to be deleted individually.';
      },
      _testId: 'warn-delete-modal',
    }).result;

    if (doNotWarnAgain) {
      Authentication.user.settings.clientFlags.doNotWarnAgainAboutDeletingTaskTemplates = true;
      await Authentication.syncSettings();
    }
  }
}
